import React from "react";
import EditorSearchIcon from "@atlaskit/icon/glyph/editor/search";

import { Grid } from "../../../UI/Grid";
import { TextField } from "../../../components/TextField";
import { Button } from "../../../UI/Button";
import useAuth from "../../login/AuthContext";
import { Checkbox } from "../../../UI/Checkbox";

export const ByNameSearchComponent = ({
  setFirstName,
  setLastName,
  setShouldSearch,
  setGlobalSearch,
  isLoading = false,
  firstName = "",
  lastName = "",
  globalSearch = false,
  disableGlobalSearch = false,
}) => {
  const { isSuperAdmin } = useAuth();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={3} alignItems="end">
          <Grid item xs={4}>
            <TextField
              value={firstName}
              type="text"
              size="small"
              id="fist-name"
              variant="outlined"
              label="First Name"
              onChange={setFirstName}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              value={lastName}
              type="text"
              size="small"
              id="last-name"
              label="Last Name"
              variant="outlined"
              onChange={setLastName}
            />
          </Grid>
          <Grid item mb={0.5}>
            <Button
              appearance="primary"
              isLoading={isLoading}
              onClick={setShouldSearch}
              iconBefore={<EditorSearchIcon label="Search" />}
            >
              Search
            </Button>
          </Grid>
          {isSuperAdmin() && !disableGlobalSearch && (
            <Grid item xs={12}>
              <Checkbox name="globalSearch" label="Global Search" isChecked={globalSearch} onChange={setGlobalSearch} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
